export const FUTUREFAIR_2026_DATA = [
  {
    galleryName: 'The Spaceless Gallery',
    booth: 'SP 1',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Paris, France & New York, NY',
    exhibitingArtists: 'Sophie Kitching',
    textDescription:
      "Merging nature and architecture, Sophie Kitching's paintings explore landscape as an active medium, shaped by memory and movement, inviting the viewer into a sensory experience with depth, surface, and scale.",
    imagesLink: '',
    galleryWebsite: 'https://www.thespacelessgallery.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'The Painting Center',
    booth: 'E1',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists:
      'Two groups. First group: Steven J. Cabral, Lisa Petker Mintz, Kathleen Beausoleil, Mary Crenshaw, Lesley Bodzy, David Willburn Second group: Kellie Lehr, Jamie Powell, Connie Brown, Rachel Volpone, Dale Emmart, Andrea Kantrowitz',
    textDescription:
      'Between Surface and Space is a group presentation by artists affiliated with The Painting Center that considers painting as a living, adaptable medium - one that continues to evolve through material experimentation, spatial engagement, and process-driven approaches. At a moment when painting is increasingly mediated by screens and circulation, this presentation insists on material presence, embodied viewing, and physical scale as critical forms of knowledge, foregrounding process, touch, and time as central to painting’s continued relevance. The presentation is organized into two interconnected sections offering distinct yet complementary modes of encounter. One emphasizes surface, density, and close looking - works that draw viewers inward through restraint, layering, and material tension. The other opens outward, presenting paintings that extend into space through scale, construction, gesture, and the physical activation of the wall and surrounding environment. Rather than functioning as a strict division, these sections create a continuous visual flow, moving viewers between proximity and distance, absorption and bodily awareness. Together, the works position painting as a responsive system - shaped by time, touch, and presence. Rather than proposing expansion as progress, the presentation insists on oscillation - between surface and space, control and openness, stillness and movement - as painting’s enduring strength. The participating artists were selected for practices that test painting’s physical limits while remaining accountable to its history. Presented in New York, Between Surface and Space reflects The Painting Center’s ongoing commitment to artist-driven experimentation and dialogue. Founded by artists in 1993, The Painting Center was established in response to a challenging art market and the limited availability of exhibition venues dedicated to painting. Through alternative, non–market-driven exhibitions, the organization has consistently supported experimental practices while fostering sustained critical exchange among artists.',
    imagesLink:
      'https://drive.google.com/drive/folders/1OWOPmF4Uhoq8P_VgBEx_e4-JGWcWRoQ8?usp=sharing',
    galleryWebsite: 'http://www.thepaintingcenter.org/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'under the pale blue',
    booth: 'E2',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Ridgewood , NY',
    exhibitingArtists: 'Adina Andrus, Breatriz Williams, Mitchell Craig',
    textDescription:
      'This presentation brings together Adina Andrus, Mitchell Craig, and Beatriz Williams, three artists who find connection and meaning through sustained engagement with the natural world. Across ceramics and painting, their practices explore how sustained attention, ritual, memory, and environment shape personal and collective experience. In a cultural moment defined by speed and saturation, the exhibition considers nature as a site for reflection, grounding, and systems of belief. Adina Andrus, born in Bucharest, Romania and based in the United States, presents large ceramic wall works that explore a self-created symbology drawn from inherited and evolving images. Through controlled, repetitive motifs and the transformation of mundane materials, her work evokes votive objects and devotional pageantry, revealing how symbols carry memory, belief, and cultural meaning across generations. Mitchell Craig, a New York City–based artist, developed his Walden series during the isolation of lockdown, drawing inspiration from Henry David Thoreau’s Walden and its emphasis on attention, repetition, and the immense potential of the ordinary. Craig repeatedly returned to small patches of grass outside his Manhattan apartment, photographing subtle shifts in light and composition. These images became the foundation for highly detailed paintings that reflect how sustained looking and constraint can transform everyday moments. Beatriz Williams, a Puerto Rican–born, New York–raised painter, explores identity, ancestry, and connection to the land through a diasporic lens. Merging portraiture and nature, her acrylic paintings dissolve boundaries between body and landscape, honoring generational memory and the belief that what we do to the earth, we do to ourselves.',
    imagesLink:
      'https://drive.google.com/drive/folders/1itZq1BmlCAvYnBFXJePsjUDbMLxSlr2P?usp=sharing',
    galleryWebsite: 'http://www.vellumartmag.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Tourné Gallery',
    booth: 'E3',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'Madalena Negrone',
    textDescription:
      'Tourné Gallery is pleased to present a solo exhibition of recent works by Madalena Negrone, building on the momentum of the recent acquisition of her large format painting by the National Gallery of Modern and Contemporary Art in Rome, which houses the world’s largest collection of modern and contemporary Italian art. This acquisition marks a major milestone in the artist’s career and follows growing institutional and collector interest, including a solo exhibition at the Museum of Art and Science in 2023. A comprehensive solo exhibition in New York will further affirm Madalena Negrone’s early contributions to quantum art, a field that is increasingly shaping the contemporary art landscape.',
    imagesLink:
      'https://drive.google.com/drive/folders/1u1T94-nReQfV94YFtLjan2s35VjNzF5K?usp=sharing',
    galleryWebsite: 'http://soilabovewater.com/thepaleblue',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Kathryn Markel Fine Art',
    booth: 'E4',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'Allyson Strafella, Fran Shalom, Zuriel Waters',
    textDescription:
      "Kathryn Markel Fine Arts' booth for Future Fair 2026 will feature three abstract artists: Fran Shalom, Allyson Strafella, and Zuriel Waters. These artists exemplify the gallery’s core focus on abstraction that emphasizes color, texture, and an inventive process. Strafella’s minimal drawings have rich surfaces that she creates with a typewriter. Shalom abstracts recognizable objects, painting many iterations before resolving a piece. Waters’ paintings toe the line of textile art whilst exuding animated personality. These artists span a range of career stages and share a deep connection to NYC.",
    imagesLink:
      'https://drive.google.com/drive/folders/1rAJDU5d6_kkGuX5aJy6jAVkYWCz1bFRk?usp=drive_link',
    galleryWebsite: 'http://www.markelfinearts.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'PMT Advisory',
    booth: 'E5',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'Garo Hakimian',
    textDescription:
      'In a world increasingly dominated by the relentless acceleration of AI and digital turnover, Garo Hakimian’s work offers a vital, grounding counter-narrative for Future Fair 2026. As an artist who has navigated the tactile, mechanical rhythm of a printing press since his youth, Hakimian embodies a unique intersection of "speed" that is psychological rather than technological. His practice—often described as a "dangerous sport" where the only certainty is mutation—rejects the polished immediacy of the digital age in favor of a visceral, physical persistence.',
    imagesLink:
      'https://drive.google.com/file/d/1VFgOpa8M-9nIe7bnqA8j7O8wfTtcW-up/view?usp=sharing',
    galleryWebsite: 'https://www.privatemuseumtours.com/art-consultation-nyc',
    priceListOrOVRLink: '',
  },
  {
    galleryName: "Janna's Gate",
    booth: 'E6',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Vermont',
    exhibitingArtists: 'Lela Jaacks, Olivia Janna Genereaux',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1fWH1NA8ESICtrQh4d0zwpnrkonDOdApT?usp=drive_link',
    galleryWebsite: 'http://www.oliviajannagenereaux.com/jannas-gate',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Stump Gallery',
    booth: 'E7',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Brooklyn, NY',
    exhibitingArtists: 'Hale Jones, Wallace Dibble',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1wOWcRq_b4_ogMJUDRRg1mwydRUH2ZDAA?usp=drive_link',
    galleryWebsite: 'http://www.stumpgallery.com/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Nancy Hoffman',
    booth: 'E8',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'Jody Guranick and Joan Bankemper/Sophie Bankemper Collaboration',
    textDescription:
      'Nature Redux. Nancy Hoffman Gallery is pleased to present a dialogue between two gallery artists: Jody Guralnick (paintings) and the Bankemper collaboration (ceramic sculptures), a Mother/ Daughter team: women committed to nature and to preserving the environment.',
    imagesLink:
      'https://drive.google.com/drive/folders/1-h53wUgPLepkFNzXc2mOSFoob4CWtqki?usp=drive_link',
    galleryWebsite: 'http://www.nancyhoffmangallery.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Loft Projects',
    booth: 'E9',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists:
      'Mia Dunn, Vycie, Melanie Delach, Aliza Stone Howard, Nicole James, Tara Lewis, Alex Maceda, Maya Mason, Taylor Keister, Avalon Lafoose, Alexandra Rubinstein, Adi Oren, Sunny Chen, Emma Hapner, Charlotte Hailstone',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1MDH3eLfLkrddsLZb5wMADdaJKqqiYv2o?usp=drive_link',
    galleryWebsite: 'https://www.loft-projectsny.com/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Exhibition A',
    booth: 'E10',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists:
      'Alec Egan, Sophia heymans, Xaio Wang, Devra Fox, Joani Tremblay, Jen Hitchings, Nikki Maloof + Special Edition Print for Future Fair (with Laura Noguera of Policroma Gallery, Medellin)',
    textDescription:
      "Exhibition A collaborates with today's most exciting artists to create limited editions and original series of work Frieze, operating at the precise intersection where accessibility meets institutional quality. This positions the platform as a perfect fit for a fair whose identity is rooted in forward-thinking collecting culture. Future Fair emphasizes collaboration and sustainability, with nearly 70 galleries from across the U.S. and abroad, offering creative and meaningful curation with more accessible price points Frieze — values that Exhibition A has championed since its inception. What makes Exhibition A's participation particularly compelling is its roster. Artists like Alec Egan, Sophia heymans, Xaio Wang, Devra Fox, Joani Tremblay, Jen Hitchings, Nikki Maloof— whose work bridges fine art and popular culture — sit alongside emerging names discovered through the platform's curated collections including \"Artists on the Rise\" and \"Sublime Minutiae.\" These aren't prints for the mass market; they are carefully edition-controlled works that hold their value and build careers. For collectors navigating Future Fair's booths, Exhibition A offers something rare: a direct, educated pathway into collecting without the gatekeeping that traditionally accompanies gallery culture. In an art world still grappling with questions of access and equity, that mission resonates deeply.",
    imagesLink:
      'https://drive.google.com/drive/folders/1x8A4EuKUePxLiEqdhUxwrj8H4V8beARm?usp=drive_link',
    galleryWebsite: 'http://www.exhibitiona.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Exhibition A',
    booth: 'SP 2',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'Laura Noguera’s Ofrenda Minima',
    textDescription:
      'Produced in collaboration with Policroma, Medellín, Colombia, this special limited-edition print will be signed by the artist. A portion of the proceeds will support Future Fair’s 2027 Pay-It-Forward Fund for rising art dealers participating in the exhibition.',
    imagesLink: '',
    galleryWebsite: 'http://www.exhibitiona.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Official Welcome',
    booth: 'E11',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Los Angeles, CA',
    exhibitingArtists: 'Diane Briones Williams',
    textDescription: '',
    imagesLink: 'https://officialwelcome.art/fairs/future-fairs-diane-briones-williams/',
    galleryWebsite: 'https://www.officialwelcome.art',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Dimensions Variable',
    booth: 'F1',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Miami',
    exhibitingArtists:
      'Alfredo Travieso, Anna Biondo, Claudia Vieira, Felice Grodin, Javier Barrera, Karen Starosta-Gilinski, Karla Kantorovich, Leyden Rodríguez-Casanova, Marcos Valella, Margrethe Aanestad, Moira Holohan, Nicole Burko, Salua Ares',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1iiWY459Xpx0guuuK1Sa0SZSmk2rQeis3?usp=sharing',
    galleryWebsite: 'https://dimensionsvariable.net',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'blue boy',
    booth: 'F2 A',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Savannah, GA & NYC, NY',
    exhibitingArtists: 'Felix Benton, Cecilia Caldiera',
    textDescription:
      'Site Service and blue boy present works by New York-based artists Felix Benton and Cecelia Caldiera. The two artists are deeply committed to making a sustained, lived practice and are actively producing in New York and beyond, yet remain under-recognized within its commercial circuits. At a moment when visibility is often tied to speed and marketability, this presentation centers dedication, experimentation, and the slower rhythms of the young artists’ studio lives. The presentation brings together varied experiences and challenges—personal, structural, and material—reflecting how Benton and Caldiera navigate New York through non-profits, shared studio spaces, alternative and temporary projects, and self-organized support systems. These artists are not defined by lack, but by an ongoing devotion to process: a genuine love for making, research, and exploration, and the daily labor of creating work without guaranteed commercial opportunity. Exhibiting these artists in New York now affirms the city as a site of practice, relation, and persistence. Site Service and blue boy aim to bridge connection— between artists and audiences, between emerging practices and broader conversations—by offering visibility to those continuing to experiment, take risks, and remain accountable to their studio practice. This presentation insists that sustained artistic inquiry, care, and commitment are vital cultural forces worth foregrounding and supporting.',
    imagesLink:
      'https://drive.google.com/drive/folders/1lgrBfsU_MorGT9BAEMR0dTRBwA-Yx2t4?usp=sharing',
    galleryWebsite: 'http://blueboy.space',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Site Service',
    booth: 'F2 B',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY, USA',
    exhibitingArtists: 'Felix Benton, Cecilia Caldiera',
    textDescription: '^',
    imagesLink: '',
    galleryWebsite: 'http://site-service.org',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Elza Kayal Gallery',
    booth: 'F3',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'Lauren Cline, Pat Lay',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1AP8HGF6WScQkpV05sh5F3syzFsvZgsxR?usp=sharing',
    galleryWebsite: 'http://elzakayal.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Soulios',
    booth: 'F4',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Nashville, Tennessee',
    exhibitingArtists: 'Arthur Robins, Matthias Duwel, Nicholas Kontaxis',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1Y2ceWAaBjxENdMSaRNPNyXD9PdaopmTW?usp=sharing',
    galleryWebsite: 'https://www.souliosgallery.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Criss Collaborations',
    booth: 'F5',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'Lesley Bodzy',
    textDescription:
      'Exhibiting Lesley Bodzy’s abstract paintings and resin-cast sculptures in New York at this moment is especially significant because her work speaks directly to the evolving conversations shaping the city’s contemporary art landscape. New York is experiencing a renewed focus on material experimentation, expanded abstraction, and practices that merge emotional depth with formal innovation. Bodzy’s work advances these dialogues with clarity and intention. Her tactile, sculptural approach to painting and her luminous resin forms embody the kind of boundary-expanding abstraction that New York audiences are actively seeking and responding to.',
    imagesLink:
      'https://drive.google.com/drive/folders/1fU4IuPRHmUGrvI8-D-6ejYixIxRPKoJo?usp=sharing',
    galleryWebsite: 'http://www.crisscollaborations.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'COURT TREE COLLECTIVE',
    booth: 'F6',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Brooklyn, NY',
    exhibitingArtists: 'Isolina Minjeong',
    textDescription:
      'The series draws from funerary sculptures in ancient Korea and Peru, regions connected to the artist’s family history, where hand-built figures served as guardians and markers of passage. Rather than replicate these influences, Isolina reinterprets gods and animals through her affinity for cartoon imagery and character design. Installed as a collective body rather than a single monument, the work considers protection, inheritance, and continuity through red earth.',
    imagesLink: '',
    galleryWebsite: 'http://courttree.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'The Vestibule',
    booth: 'F7',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Seattle, WA, US',
    exhibitingArtists: 'Mana Mehrabian and Stefan Gonzales',
    textDescription:
      'In photo media and installation, Mana Mehrabian and Stefan Gonzales recollect and document personal and cultural histories. Mehrabian, an Iranian immigrant living in Eastern Washington, explores themes of identity, home, and memory through the lens of the immigrant experience. Gonzales, a non-binary Indigenous artist, uses photography, performance, and sculpture to draw to attention the origin story of materials that shape our everyday lives. With deceptively beautiful pieces, these artists provoke difficult reflection on how documentation controls history and imagery.',
    imagesLink:
      'https://drive.google.com/drive/folders/1XDKXZ3i8y-phds-idjjz2m8uVDKriwWa?usp=sharing',
    galleryWebsite: 'http://tinneycontemporary.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Encarte',
    booth: 'F8',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Mexico City, Mexico',
    exhibitingArtists: 'Cristian Franco',
    textDescription:
      'At a historic moment in which the United States stands at the center of global debate — particularly around migration, power, and political redefinition — Cristian Franco’s series Lysergic Politics offers a timely and critical perspective. Through psychedelic portraits of key figures from the 20th and 21st centuries, Franco transports these characters into a lysergic plane where their symbolic and ideological weight is deconstructed. It is about seeing the person from within, at a molecular level, stripping away the historical burden that surrounds them in order to expose how narratives of power are constructed.',
    imagesLink:
      'https://drive.google.com/drive/folders/104xRgkUR60WwFlVIKpIxmep0Iq6p6SdN?usp=sharing',
    galleryWebsite: 'http://www.encartegaleria.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Hexum Gallery',
    booth: 'F9',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Montpelier, VT',
    exhibitingArtists: 'Elizabeth Powell',
    textDescription:
      'Elizabeth Powell’s paintings operate through a visual vocabulary in which abstracted shapes evoke bodily interiors, lingerie structures, and organic tension. Her hand-rendered nets, knots, ribbons, and corset-like closures suggest forms held in tension between protection and constraint, articulating in paint what is often difficult to describe with words: the complexity of feminine experience, containment, and release.',
    imagesLink:
      'https://drive.google.com/file/d/1PwfpgifjvjYlA_vdU-1ECGL9W3k_7Q47/view?usp=sharing',
    galleryWebsite: 'http://www.hexumgalery.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'OCD',
    booth: 'F10',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Nomadic',
    exhibitingArtists: 'Nadia Younes, Adriana Wynne Ronson',
    textDescription:
      'OCD Gallery is pleased to present a focused two-artist presentation examining the charged intersection of the industrial and the natural between a two-artist presentation. Nadia Younes and Adriana Wynne Ronson both work with industrial materials—steel, resin, conduit, bronze, glass, demolition debris, but redirect them toward forms that register endurance and vitality. Their practices do not illustrate politics or identity; they embed them in Material.',
    imagesLink:
      'https://drive.google.com/drive/folders/1CZ-5tEAMqb8pzNXZxNVEG7cHcS3c9v0g?usp=sharing',
    galleryWebsite: 'http://oscarchloedirectory.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Wolf & Nomad',
    booth: 'F12',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Miami, FL',
    exhibitingArtists: 'Alejandra Aristizabal, Carla Freschi, Pajarito, Vanessa Valero',
    textDescription: '',
    imagesLink: '',
    galleryWebsite: 'https://www.wolfandnomad.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Artbooth Gallery',
    booth: 'F13',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Abu Dhabi, Seoul',
    exhibitingArtists: 'David Najib Kasir',
    textDescription:
      'Artbooth Gallery is pleased to announce “Beauty and Ruin,” a poignant solo exhibition by Milwaukee based artist David Najib Kasir. The exhibition will be showcased at Future Fair New York from May 13 to 16, 2026, located at Booth F13. In this evocative body of work, Kasir interrogates the role of Western media in shaping cultural narratives while turning a "caring and concerning lens" toward the systemic destruction of families across the Middle East. As an American artist born to a Syrian mother and Iraqi father, Kasir’s practice is an intimate reclamation of his heritage against a backdrop of geopolitical erasure.',
    imagesLink:
      'https://drive.google.com/drive/folders/1xHgxgX0F8t23nf4toyUsGHCQgzvL_SlC?usp=sharing',
    galleryWebsite: 'http://www.artboothgallery.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Vellum Projects',
    booth: 'F14',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Brooklyn, NY',
    exhibitingArtists:
      'Jennifer Deppe Parker, Steven Rudin, Diana Wege, Marcy Brafman, Zoe Elena Moldenhauer',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/17DZtEmcPlAY4v7byPL-kWaAIt6ZWHmVT?usp=sharing',
    galleryWebsite: 'https://thevestibule.org/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Refusés',
    booth: 'F15',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'London, UK',
    exhibitingArtists: 'Allegra Esclapon, Samah Rafiq',
    textDescription:
      'This presentation brings together Samah Rafiq and Allegra Esclapon through a shared investigation of shine as a vessel for reflection. Rafiq’s practice centres on how ideas of the sacred are constructed and experienced in everyday life. Drawing from religious painting, where light historically signified divine presence, she traces how similar visual cues now appear in advertising and popular imagery. Rafiq’s exaggerated use of shine becomes a way of questioning what we choose to elevate, desire, or worship. In a new body of work proposed for Future Fair, Rafiq makes close-up paintings of shiny but distorted clinking wine glasses. As a Muslim woman, alcohol carries particular significance for Rafiq, and these sparkling drinking vessels become charged sites for her continued exploration into our perception of the sacred or profane. In the sculptural realm, Esclapon makes ceramic vessels derived from photographic images of bodies in motion. She isolates fleeting gestures and translates them into abstract form. Esclapon’s unique and painterly use of glaze plays a critical role in practice. She uses the shine to activate her sculptures, guiding light to emphasize or withhold form and shape the viewer’s experience of the object. By manipulating light through the application of shine, her vessels bring movement back into the material, but treat gesture as a form of memory rather than a fixed representation. In the context of New York, a city saturated by visual imagery, these artists offer a pause. Rafiq and Esclapon invite viewers to slow down and consider where attention is being directed, and why. Our culture is shaped by social media, misinformation, and polarized politics. Their work opens a timely dialogue around surface, visibility, and the power embedded in what we are encouraged to look at, or not.',
    imagesLink:
      'https://drive.google.com/drive/folders/1EfpcE1aACRqE6rTo5aVrBW76_4hsd5GV?usp=sharing',
    galleryWebsite: 'http://www.refuses.info',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Collective Z Gallery',
    booth: 'F16',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'Alex Z. Wang; Marina Christy',
    textDescription:
      'At a moment when the ground beneath us feels anything but stable — politically, ecologically, psychologically — Threshold brings together new paintings by Alex Z. Wang and Marina Christy to map the interior and exterior landscapes of a world in flux.',
    imagesLink:
      'https://drive.google.com/drive/folders/1cr97fME8i9MDrFfo2pRIQaUqJRF_1yhl?usp=sharing',
    galleryWebsite: 'http://www.collectivez.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Harsh Collective',
    booth: 'F17',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'Rania Abdalla Kadafour, Kayla Dantz',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1SrN2aA7qinfAvGl_PDr0fUIKanYBIJ-9?usp=drive_link',
    galleryWebsite: 'http://www.harshcollective.com/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Wondering People',
    booth: 'R1',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'London',
    exhibitingArtists: 'Sopho Mamaladze',
    textDescription:
      'Wondering People is proud to present the work of Tbilisi-born artist Sopho Mamaladze. Her practice explores identity, transformation and memory through a symbolic visual language. Drawing on mythology and archetypes, her figures often hold tensions between pain and strength, fear and resilience. Through objects and stories from childhood, her work invites a sense of nostalgia and familiarity, playing with boundaries between self and other, past and present, reality and dreams.',
    imagesLink:
      'https://drive.google.com/drive/folders/19hQpDDM0qPrkgtzetnNKBnJLE212BNvM?usp=sharing',
    galleryWebsite: 'http://www.wonderingpeople.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: '81 Leonard Gallery',
    booth: 'R2',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY, USA',
    exhibitingArtists: 'Francine Tint, Nancy Pantirer, Farangiz Yusupova, Alison Kruvant',
    textDescription:
      'The works of Nancy Pantirer, Francine Tint, Alison Kruvant, and Farangiz Yusupova demonstrate that abstraction is a shared language that persists across time. While contemporary discourse often emphasizes generational divides, this exhibition highlights the continuities and shifting perspectives across different stages of artistic careers. New York City has long been a center for abstraction; from the history of abstract expressionism to the many experimental movements that followed, New York has shaped the making and understanding of abstract art. Yet, the contributions of women to that history have often been sidelined and their market undervalued. This show continues and diversifies that legacy through an intergenerational dialogue between four women artists whose practices are influenced by the energy of the city and whose varied career trajectories embody the ethos of 81 Leonard Gallery’s mission as an intergenerational artist-run space.',
    imagesLink:
      'https://drive.google.com/drive/folders/1woYLofYrHve_eXvTAmpbBRtscyMjy1cW?usp=sharing',
    galleryWebsite: 'http://81leonardgallery.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Gillian Jason Gallery',
    booth: 'R3',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'London, UK',
    exhibitingArtists: 'Colette LaVette',
    textDescription:
      'Gillian Jason Gallery presents a solo presentation of Colette LaVette, whose paintings conjure a mystical realm where utopia and dystopia coexist, revealing the complexities of human nature through a distinctly contemporary reimagining of Rococo aesthetics. LaVette’s delicate chromatic palette, opulent drapery, and ornamental detail are tempered by a profound engagement with our earliest, most instinctive selves. Her practice asks what remains of us beneath social conditioning - what it means to be human in a primordial, visceral sense.',
    imagesLink:
      'https://drive.google.com/drive/folders/1rsTNIuEHDz1-Qa-ngaE4kpAnxaNGnHFs?usp=sharing',
    galleryWebsite: 'http://www.gillianjason.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Abigail Ogilvy Gallery',
    booth: 'R4',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Los Angeles, CA, USA',
    exhibitingArtists: 'Natalia Wróbel, Alison Croney Moses, Tallulah Dirnfeld',
    textDescription:
      'A three-person exhibition featuring Tallulah Dirnfeld, Natalia Wróbel, and Alison Croney Moses. Together, their practices examine how individuals move through psychological, emotional, and embodied change. The booth brings these artists into conversation around internal states, learned behaviors, inherited memory, and the processes that shape identity over time.',
    imagesLink:
      'https://drive.google.com/drive/folders/1QGLZAiFIKnd7cLL6AOt3VkE4RjA2qXBR?usp=sharing',
    galleryWebsite: 'http://abigailogilvy.com/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Feia',
    booth: 'R5',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Los Angeles, CA, USA',
    exhibitingArtists: 'Paul Anagnostopoulos',
    textDescription:
      '“There’s a starman waiting in the sky” - David Bowie. Feia is proud to present Catasterism, a solo exhibition by Long Island born and NYC based Paul Anagnostopoulos on the occasion of the 6th edition of Future Fair in New York City. Catasterism holds space for a new body of work by Anagnostopoulos that reimagines the mythic love between Dionysus and Ampelos through a contemporary, queer lens. Drawing from Nonnus’s Dionysiaca and Ovid’s Metamorphoses, Anagnostopoulos traces the dual endings of the myth, which both detail Ampelos’s death and Dionysus’s act of immortalization. While the former transforms Ampelos into the first ever grapevine, Ovid instead invokes a catasterism, transfiguring him into Vindemitor, the celestial grape-gatherer within the constellation of Virgo.',
    imagesLink:
      'https://drive.google.com/drive/folders/1evU6Hayo6L00j3rA0Pd9sBIhmx0ic_kr?usp=sharing',
    galleryWebsite: 'http://feia.studio',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'TINNEY',
    booth: 'R6',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Nashville',
    exhibitingArtists: 'Megan Greene, Kimia Ferdowsi Kline, Erica Westenberger',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1DAHIk1BSs46z21RgnrOVXoKQpRWKXZbb?usp=sharing',
    galleryWebsite: 'http://tournegallery.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Lola Gallery',
    booth: 'R7',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Los Angeles, CA, United States',
    exhibitingArtists: 'April Street, Vivien Chung, Ellen Jong in Collaboration with Aura Friedman',
    textDescription:
      'Lola Gallery is pleased to present ‘Of Living Deliciously,’ a group show consisting of work from four Los Angeles based artists: April Street, Vivien Chung, and Ellen Jong in collaboration with Aura Friedman. Each of these artists shares a certain delicacy of passion, communicated through their unique intentionality of material and emphasis on identity, physicality, and the ephemeral nature of self.',
    imagesLink:
      'https://drive.google.com/drive/folders/10hdD5Fuk5VvS9ef7TqNb7z_z6FuRpQgz?usp=sharing',
    galleryWebsite: 'http://lolagallery.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Opa Projects',
    booth: 'R8',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Miami, FL, US',
    exhibitingArtists: 'Jessica Taylor Bellamy, Emily Ferguson, Bryce Delplanque',
    textDescription:
      'This presentation brings together three artists whose practices speak directly to the current moment, each in a distinct but complementary way. Jessica Taylor Bellamy’s work resonates strongly in New York through its engagement with data, memory, and urban environments shaped by climate and media saturation. Emily Ferguson offers a quieter but equally powerful counterpoint, with paintings that explore intimacy, vulnerability, and the inner emotional landscape—subjects that feel especially relevant today. Bryce Delplanque approaches painting through images already circulating in our visual culture, questioning how we look, consume, and assign value. Together, these works reflect different ways of navigating contemporary life, making this presentation particularly timely for a New York audience.',
    imagesLink: '',
    galleryWebsite: 'https://www.opaprojects.com/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Blah Blah Gallery',
    booth: 'R9',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Phialdelphia, PA',
    exhibitingArtists: 'Julia Policastro and Sydney Vize',
    textDescription:
      'This presentation brings together the work of Julia Policastro and Sydney Vize, two artists whose practices use material to explore tension, contradiction, and embodied ways of seeing. Policastro’s recent works move into sculptural and surreal territory, extending physically from the wall and blurring the boundary between painting and object. Informed by an interest in architecture, early perspective systems, and landscape traditions, her paintings use structure as a starting point rather than a stable framework. Bodily elements, including hands that appear to emerge from or press against the surface, disrupt this order and introduce psychological tension. The work reflects her ongoing exploration of how form, gesture, and material buildup can hold unexpected shifts between intention and outcome. Vize’s practice takes shape around moments that are simultaneously pleasurable and emotionally or intellectually destabilizing. She is interested in affective responses that feel incompatible yet occur at the same time. Working with wax, stitching, and layered mixed media, Vize creates soft, restrained surfaces that act as containers for these contradictions. Wax binds and obscures, while stitching suggests acts of joining, mending, and restraint. Her work seeks to give form to the gaps between feeling and thought, allowing ambiguity and vulnerability to remain visible. Presented together, the artists’ material approaches create a dialogue between physical assertion and emotional containment. Policastro’s sculptural interventions assert bodily presence and spatial tension, while Vize’s muted palette and tactile processes emphasize interiority and affect. To support this relationship, I plan to paint the booth a pale blue, creating a subtle backdrop that highlights both practices and their material differences.',
    imagesLink: '',
    galleryWebsite: 'http://blahblahgallery.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'GOCA by Garde',
    booth: 'R10',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY, USA / Tokyo, Japan',
    exhibitingArtists: 'Noriko Shinohara, Ai Sogawa',
    textDescription:
      'Currents of Memory brings together the emotionally charged narratives of Noriko Shinohara and the atmospheric abstractions of Ai Sogawa Campbell in a dialogue that navigates time, memory, and embodied experience. In a moment when identity and belonging are constantly renegotiated, Currents of Memory proposes that personal histories are not static documents but flowing energies—reshaped by time, geography, and emotional gravity.',
    imagesLink:
      'https://drive.google.com/drive/folders/1QAqin8pWcwZW9BV6OsAva5XnzqxLAthf?usp=sharing',
    galleryWebsite: 'http://goca.gallery',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'GALLERY2',
    booth: 'R11',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Seoul, Jeju, South Korea',
    exhibitingArtists: 'Hyunsun Jeon, Suyeon Kim',
    textDescription:
      'Collect, record, and reconstruct is the tangible process to which Suyeon Kim and Hyunsun Jeon, two young Korean female artists, ground their practices. The practices of the two artists are used to depict the translation of visual forms and not a specific story, of personal memories, a piece of imagery, and a delicate state of the emotional condition. The two artists experiment with how to choose materials and how to build elements through the battle of simulated and abstract art. Their artistic output gives a particular understanding of the present Korean experience in New York against a background of artistic diversity that integrates concerns that are universal to perceptions and memories, and image building.',
    imagesLink: '',
    galleryWebsite: 'http://www.gallery2.co.kr/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Palí Galería',
    booth: 'R12',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Mexico City, Mexico',
    exhibitingArtists: 'Citlali Haro, Cloe Galasso',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1-jK3AfFBKI_n6rQCPIUnroX8p_kOyK8f?usp=sharing',
    galleryWebsite: 'http://paligaleria.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'NowHere',
    booth: 'R13',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'exonemo: Kensuke Sembo and Yae Akaiwa',
    textDescription:
      'NowHere presents a group of works by artist-duo exonemo, centered on the concept of randomness: a theme that resonates deeply in a city known for its endless stream of output and input. The installation is a generative work in which a computer attempts to guess a random passcode. The moment it is solved, a mounted hatchet is triggered and released, destroying its computer in one swift motion.',
    imagesLink:
      'https://drive.google.com/drive/folders/1_C_hytn096eLTJuVS4jL4KpIa3dm_Nww?usp=sharing',
    galleryWebsite: 'http://www.nowhere-nyc.com/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'D.D.D.D.',
    booth: 'R14 A',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, Singapore',
    exhibitingArtists: 'Catherine Birk',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1mZ6XstK9mFaVbfcB8ZO36rAkIUIZFQcV?usp=sharing',
    galleryWebsite: 'https://dddd.pictures',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'SALMA',
    booth: 'R14 B',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'SOHO, NYC',
    exhibitingArtists: 'Zhi Wei Hiu',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1yhfbYMP_c_YyOYSookyPTmUjxJFV3hx3?usp=sharing',
    galleryWebsite: 'https://salmasarriedine.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'LaiSun Keane',
    booth: 'R15',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Boston, MA',
    exhibitingArtists: 'YehRim Lee, Chase Travaille, Campbell-Lynn McLean',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1JBLwXkh568weLQZr5MZ0pec8xyP8oLbf?usp=sharing',
    galleryWebsite: 'http://laisunkeane.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'PG Gallery',
    booth: 'R16',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Seoul, South Korea',
    exhibitingArtists: 'Sacco Arai, Siiz',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1-MCvIkHoXKE4cT8AErMilRsRZkN_Yw6l?usp=sharing',
    galleryWebsite: 'https://playgroundprojectseoul.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Alison Milne Co.',
    booth: 'T1',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Toronto, Ontario, Canada',
    exhibitingArtists: 'Kirsten Sims',
    textDescription:
      'Alison Milne Gallery presents a focused solo exhibition of a new body of work created specifically for Future Fair 2026 by South African artist Kirsten Sims. Sims is known for her vibrant, narrative-driven paintings that balance whimsy and humor with quiet emotional depth. Through gestural brushwork, intuitive color, and recurring characters, she elevates everyday moments into scenes that feel immediately intimate and broadly relatable. Rooted in illustration yet fully realized within contemporary painting, her practice explores the spaces between solitude and community, memory and imagination, and the performative nature of human experience.',
    imagesLink:
      'https://drive.google.com/drive/folders/1keECkU3sR4cfglTzltp-F9MlF43E5bGB?usp=sharing',
    galleryWebsite: 'https://www.alisonmilne.com/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Michele Mariaud Gallery',
    booth: 'T10',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Bellport, NY, USA & Paris, France',
    exhibitingArtists: 'Diogo Barros, Galud, Sam Bloch',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1yQp4nzLHcZNl4eOA9vLTd0BjlVlUwXK9?usp=sharing',
    galleryWebsite: 'http://michelemariaud.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Current State Studio',
    booth: 'T2',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Los Angeles, CA',
    exhibitingArtists: 'Miao Jiang, Song Li, Yiting Liu',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1__H34MSA1HZ9vN8HUsLzFL6fMXfFzfYb?usp=sharing',
    galleryWebsite: 'http://currentstatestudio.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Jakupsil',
    booth: 'T3',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, New York',
    exhibitingArtists: 'Anikoon, Adam Handler, Raymond Ishii',
    textDescription:
      'At Future Fair, Jakupsil is pleased to present recent paintings by Anikoon, Adam Handler, and Raymond Ishii, coming from Korea, USA and Japan. Bringing together three painters working in cross-cultural contexts, the booth is organized around a shared preoccupation: the prepared surface as the origin of meaning. Each artist has developed a distinct process-dense gestural accumulation, sandblasted layers, and mineral filler layering-through which the physical constitution of the canvas becomes inseparable from what the work proposes conceptually.',
    imagesLink:
      'https://drive.google.com/drive/folders/1OoNwN0dp5OKEH8X5a4n4XH0660EofNNQ?usp=sharing',
    galleryWebsite: 'http://jakupsil.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'ABC x Startup',
    booth: 'T4 A',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'San Francisco, CA',
    exhibitingArtists: 'Ray Beldner and Katherine Filice',
    textDescription:
      'This joint presentation brings together two distinct yet complementary material practices that explore how fragments—whether drawn from the natural world or from art history—can be transformed into new visual languages. Though their materials differ, their work shares core concerns: how surfaces accumulate histories, how experience leaves traces, and how art becomes a way of recording and reconstructing meaning over time. In Katherine’s work, the forest functions as an active collaborator. Ink, sculpted paper, mica, ground stone, and buried substrates absorb the marks of weather, soil, insects, and duration. These works behave as layered ecological documents—part artifact, part drawing, part spiritual record—where natural processes assert their own agency alongside human intention. Ray’s assemblage works similarly begin with fragments, this time drawn from the visual archive of art history. Images torn from books and catalogs are reconfigured into intuitive, sculptural compositions influenced by modernist shape-makers like Henry Moore and Jean Arp. What begins as paper evolves into structure, rhythm, and spatial presence, transforming cultural memory into new, materially grounded forms.',
    imagesLink:
      'https://drive.google.com/drive/folders/1NrSp4S_ZLQhLhfdCt7l0fNHQYrHDu4jQ?usp=sharing',
    galleryWebsite: 'https://www.startup-art.com/curatorial-portfolio',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Wishbone Gallery',
    booth: 'T5',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Montréal, Canada',
    exhibitingArtists: 'Kaori Izumiya, Magali Cazo, Florencia Rothschild',
    textDescription:
      'For Future Fair 2026, Wishbone Gallery is pleased to present a curated presentation featuring three women artists from three continents: Kaori Izumiya (Japan), Florencia Rothschild (Argentina), and Magali Cazo (France). Bringing together painting, ceramics, and ink, their practices enter into a quiet and thoughtful dialogue, forming a shared visual language that privileges nuance, sensitivity, and introspection. Across distinct cultural and material approaches, these three artists construct an atmosphere of gentleness—an intentional counterpoint to the velocity and fracture of the contemporary world. Their works propose spaces of pause and attentiveness, where softness is not synonymous with fragility, but rather with resilience, care, and sustained observation. Each artist draws from personal narratives and lived experience, transforming intimate questions into universal forms. Through figurative and abstract gestures, their works address themes of identity, memory, domesticity, and the emotional landscapes shaped by both inner life and collective experience. Painting converses with ceramics; ink responds to surface and form, creating a layered environment in which materials echo and reinforce one another. Together, Izumiya, Rothschild, and Cazo articulate a poetic and grounded vision—one that embraces vulnerability as a strength and affirms tenderness as a vital mode of engagement with the present moment.',
    imagesLink:
      'https://drive.google.com/drive/folders/1UbCIGPJ5VkNnrwjnnLLwkLxz9MB5JPTn?usp=sharing',
    galleryWebsite: 'https://wishboneart.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'BolsterArts',
    booth: 'T6',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'Chris Cortez and Ali Sutton',
    textDescription:
      'BolsterArts is pleased to present "A Conditional Sky", bringing together oil paintings by Chris Cortez and Ali Sutton. Across distinct bodies of work, both artists treat atmosphere as an affective register, tracing how interior life is negotiated under conditions of stability and care. Cortez’s "Bajo la Misma Luna" is a series of sky paintings derived from an ongoing archive of photographs she collects while traveling to her family hometown, Joaquín Camaño, Mexico. Cortez’s restraint, light suspended, time stalled, invokes longing and nostalgia without collapsing into sentimentality. The clouds pull against the sky as light breaks through, a threshold, a moment just before something happens or just after it has passed. Referencing the film "Bajo la Misma Luna", Cortez frames the sky as a tether, a shared structure we can look to when care is stretched across borders. Sutton’s psychologically charged figurative paintings draw from her lived experience with Obsessive Compulsive Disorder. Her figures inhabit mythic environments that echo the fever of intrusive thought and the entanglement of narratives we cannot escape. Rendered in radiant, unnatural color, the works hover in a heightened register. Memory, dream, or dread: a figure gnaws at a deer’s leg or crushes a raw egg against her lips. Appetite and self-surveillance coexist, as indulgence tips into aftermath. In Sutton’s work, care is not comfort, it is the ongoing labor of witnessing the self without turning away. Exhibited together in New York at this moment, these works feel urgently attuned to contemporary life, where mental health, migration, and access to stability shape everyday experience. Sutton and Cortez propose painting as both witness and refuge, mapping what it means to remain tethered, to one another and to the self, beneath the same sky.',
    imagesLink:
      'https://drive.google.com/file/d/1VXKrAMZb0JrGwcvYlMbZr3hFAZPXk3HL/view?usp=sharing',
    galleryWebsite: 'http://www.bolsterarts.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Good Naked',
    booth: 'T7',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'David McDonough / Carl Durkow',
    textDescription:
      'Seeing is Feeling. This presentation brings together the work of artists David McDonough and Carl Durkow, exploring the relationship between the seen and the felt. David McDonough approaches the unseen from a microscopic level, giving form to quasi-psychedelic memories of beguiling organic forms. Carl Durkow focuses on making distinctive and often anthropomorphic domestic objects to be lived with and cared for. Each artist follows a thread of image making that is as sensitive to touch as it is to visual phenomena. The forms in each opus are unconstrained by certitude, happily following the meandering and sometimes hallucinogenic path of nature. Both artists hover between abstraction and representation, informed by mythological archetypes and the cyclical processes of growth and decomposition. The works offer objects as sites of emergence—where the familiar world slips into dream logic, and symbolic meaning flickers in and out of view. The installation will emphasize spatial rhythm and sensory experience. McDonough’s paintings vary in scale from intimate panels and wall-hung ceramics to larger immersive works, creating an atmospheric field of color and gesture. Durkow’s sculptures, placed in conversation with these painted environments, will invite physical proximity. Viewers navigating between pieces will experience subtle shifts of light, weight, and perspective. Together, the arrangement encourages slow looking and embodied engagement.',
    imagesLink:
      'https://drive.google.com/drive/folders/1wNg_xY_7xUNN2mvY8QehyhFnqkTruReG?usp=sharing',
    galleryWebsite: 'http://www.goodnakedgallery.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Elijah Wheat Showroom',
    booth: 'T8',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Newburgh, NY',
    exhibitingArtists: 'Dave Tavacol',
    textDescription:
      'The jockstrap pulls me back to the charged awkwardness of adolescence—gym class moments when vulnerability rubbed up against a dawning awareness of desire. The athletic supporter, the heat of communal showers, and the constant swing between excitement and fear existed in a narrow space between hiding and exposure. That tension mirrors my experience growing up as a gay Iranian American during the Hostage Crisis, the AIDS epidemic, and the rise of Christian fundamentalism. Learning when to speak, when to stay silent, and how to survive sexuality and identity across cultural and national lines shaped who I became—and still shapes how I move through the world. Those same tensions run through today’s socio-political climate, where disclosure can mean deportation, rendition, or death—whether because you are undocumented, trans, or simply have the “wrong” shade of skin. And bathrooms and locker rooms remain contested spaces where these political battles play out.',
    imagesLink: 'https://drive.google.com/drive/u/2/folders/1MHdWkab8CX5-ENWp9ojhNxLU8hCAkn3s',
    galleryWebsite: 'https://www.elijahwheatshowroom.com/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Janey',
    booth: 'T9',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Cambridge, Canada',
    exhibitingArtists: 'Claire Drummond, Britt Elise Grayson, Yvonne Weiss',
    textDescription:
      'Janey presents Canadian emerging artists Claire Drummond, Britt Elise Grayson, and Yvonne Weiss in an exhibition centered on metamorphosis. Through figurative, sculptural, and nature-based works, each artist explores metamorphosis as both a concept and an experience, inviting viewers to witness transformation, emergence, and the possibility of all things. Future Fair marks the gallery’s debut, as well as the first appearance of all participating artists at an international art fair and in New York City.',
    imagesLink:
      'https://drive.google.com/drive/folders/15zo9ea1rUX5yNmkYVJQa9Um4AfRgZvGN?usp=sharing',
    galleryWebsite: 'http://www.janey.gallery',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Galerie Robertson Arès',
    booth: 'U1',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Montreal, Québec, Canada',
    exhibitingArtists: 'Zoe Hawk, Valérie Gobeil',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1A0kq4x4rRDMxATVBrSjuAuk2vln39pEz?usp=sharing',
    galleryWebsite: 'http://galerierobertsonares.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Rosebud Contemporary',
    booth: 'U2',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'Ebenezer Singh, RJ Calabrese',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1q6CDURJgu1atTyzdNK48GNmtYny17Pqr?usp=sharing',
    galleryWebsite: 'http://www.rosebudcontemporary.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Policroma Gallery',
    booth: 'U3',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Medellín, Colombia',
    exhibitingArtists: 'Laura Noguera',
    textDescription:
      'Monumentality has become one of the most contested cultural questions in recent years. What deserves to be publicly remembered at an imposing scale remains the subject of ongoing debate. Laura Noguera (MFA, New York Academy of Art) approaches this discussion from an unexpected position: she brings into oil painting a problem traditionally associated with sculpture; she reframes a matter of public memory through an intimate, autobiographical lens; and she draws from the margins of femininity and Latin American/Caribbean experience to address an issue long centered within dominant Western narratives. In Noguera’s work, scale is never fixed. A stone may become a volcano, a puddle aspires to the condition of a sea, and a navel recalls—quietly but insistently—that it marks a center around which meaning is organized. Resisting stable figuration and literal representation, the artist develops what she describes as a “pedagogy of non-proportion,” where memory—both personal and collective, factual and constructed—remains unstable. As Noguera notes, “everything becomes everything else depending on where one looks.” This logic finds a concentrated form in her polyptychs, produced using the residual oil paint left on her palette after completing large-scale works. Here, the crater of a navel appears alongside that of a volcano, collapsing distinctions between the monumental and the intimate. For Future Fair 2026, presented with the Colombian gallery Policroma, these polyptychs are shown alongside works that reflect on fragile equilibrium, relative solidity, and the fluid nature of memory. Shown in a city structured by excess, scale, and competing narratives of permanence, this presentation reframes monumentality from an intimate and materially grounded perspective. In the context of New York City, where the artist now lives and works, Noguera’s oil paintings shift the discussion away from dominant monumental logics and toward questions of fragility, proportion, and lived experience.',
    imagesLink:
      'https://drive.google.com/drive/folders/1Cg2NJ06qbQCi6GavizqCMGsHvMEOkAfT?usp=sharing',
    galleryWebsite: 'https://policroma.co/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'The Contemporary Art Modern Project',
    booth: 'U4',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'North Miami, Florida',
    exhibitingArtists:
      'Deborah Simon, Micheal Sylvan Robinson, Rosana Machado Rodriguez, Silvana Soriano',
    textDescription: '',
    imagesLink: '',
    galleryWebsite: 'http://www.thecampgallery.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Blumka',
    booth: 'U5',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'Karl Orion',
    textDescription:
      'Karl Orion’s work is particularly resonant to exhibit in New York at this moment, as it addresses a growing psychological and cultural distance between metropolitan life and the natural systems that quietly shape human experience. Through allegorical botanical painting, Orion dissolves the often rigid boundaries imposed between humanity and the natural world, offering spaces of reflection, refuge, and emotional recalibration.',
    imagesLink:
      'https://drive.google.com/drive/folders/1n3Du4W9sU7B58bSuSj4JpPRZ1Fs2dYAJ?usp=sharing',
    galleryWebsite: 'https://www.blumkacontemporary.com/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Hashimoto Contemporary',
    booth: 'U6',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York City, San Francisco',
    exhibitingArtists: 'Angela Burson & Scott Albrecht',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1-I00VDIVWd09-o-kUCDVbp1OsYPG6e8Z?usp=sharing',
    galleryWebsite: 'http://www.hashimotocontemporary.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'CRUISE',
    booth: 'SP 3',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Minneapolis, MN',
    exhibitingArtists: 'Xavier Tavera',
    textDescription:
      'Xavier Tavera’s Unsettled begins with the civil unrest that shook Minneapolis and the nation in January 2026. In vivid street scenes, he depicts protesters, state perpetrators of violence, and the material traces of urban upheaval. These documentary images are given an unexpected context: Tavera mounts them onto photographs of pastoral Minnesota landscapes. Tavera layers his artistic and personal experiences onto broader questions drawn from the history of photography and the land, particularly the role photography has played in establishing standard myths of equilibrium found in the interior Midwest. Two Minnesotas usually kept apart, visually and politically, are joined.',
    imagesLink:
      'https://drive.google.com/drive/folders/1048rjBw-RPiXW42lm6w2jJp-ps-znk_m?usp=sharing',
    galleryWebsite: 'https://www.cruisempls.com/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Abbozzo Gallery',
    booth: 'U8',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Toronto, Ontario, Canada',
    exhibitingArtists: 'Miles Ingrassia, John Vitale',
    textDescription:
      'Abbozzo Gallery is presenting a dual artist booth of Miles Ingrassia and John Vitale. Both artists practice in the painting tradition and are known for their exploration of colour and form, but approach their practice from opposing perspectives. Vitale aims to create form from the abstract, and Ingrassia aims to abstract the image. Ingrassia aims to “trouble” contemporary conceptions of masculinity, and “troubles” realism with his stark, vibrant underpainting and gestural brush strokes in his dramatic and narrative compositions. Vitale creates tension in his colourful but soft matte compositions. Vitale’s practice draws from early abstract expressionism, color field painting, the physicality of action painting, and the visual language of design.',
    imagesLink:
      'https://drive.google.com/drive/folders/1XOyqXf-v2eFzOspN4z3-8mAL5o5Tfajs?usp=sharing',
    galleryWebsite: 'http://abbozzogallery.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'The Empty Circle',
    booth: 'U9',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY',
    exhibitingArtists: 'Daniel Kukla',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1UfPjcT5jr9LqQIPBoW6Dgk08g7wU0FA4?usp=sharing',
    galleryWebsite: 'http://www.theemptycircle.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'SEIZAN',
    booth: 'U10',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York, NY, United States / Tokyo, Japan',
    exhibitingArtists: 'Marina Berio, Asako Tabata, Miné Okubo',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1MpBWmhKOedLmerfjd_xBdQObL_QfOTnb?usp=sharing',
    galleryWebsite: 'http://www.seizan-gallery.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Alday Hunken Gallery',
    booth: 'U11',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Atlanta, Georgia, USA and Mexico City, Mexico',
    exhibitingArtists: 'Tyreek Morrison and Frank Morrison',
    textDescription:
      'For this edition, we are proud to present Tyreek Morrison and Frank Morrison, father and son, each building a distinct visual language from shared roots. Their practices do not imitate one another. They are in dialogue. The work asks what it means to inherit a creative impulse and then make it entirely your own. Beyond sales or visibility, success for us is patience: giving artists the room to develop without rushing them into market narratives. Future Fair has always understood that, and we are grateful to be part of this community for the first time.',
    imagesLink:
      'https://drive.google.com/drive/folders/1gjQnZFhpLUh39jIZRvUL6GtMz_4P48AB?usp=sharing',
    galleryWebsite: 'http://aldayhunken.com',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'artbug gallery',
    booth: 'U12',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Los Angeles, CA & Mexico City',
    exhibitingArtists: 'Carlos Rittner, Miguel Casco, Vanessa Zarate',
    textDescription: '',
    imagesLink:
      'https://drive.google.com/drive/folders/1yZPsPOLWgUZc5UWHNwSuaUPu8GDIvCc0?usp=sharing',
    galleryWebsite: 'https://artbug.net',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Geary Contemporary',
    booth: 'U13',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'Salisbury, CT',
    exhibitingArtists: 'Cammi Climaco, Alan Prazniak & Reeve Schley',
    textDescription:
      'Geary is thrilled to present the work of Alan Prazniak, Reeve Schley and Cammi Climaco. The paintings of Prazniak and Schley explore landscapes - Prazniak with extracted forms and saturated colors and Schley with gestural brushstrokes and bold colors. Climaco’s bright and expressive ceramic work analyzes the relationships between our personhood and possessions - everything is something; a memory, reaction, celebration or homage. Through Prazniak’s abstracted spaces, Schley’s dreamy depictions of place and Climaco’s object studies - our booth invites viewers to consider themselves in both their possessions, spaces and memories. All with significant ties to New York City throughout their careers, these artists explore themes of place and intimacy in ways that feel vital and necessary in the world today.',
    imagesLink:
      'https://drive.google.com/drive/folders/1Si9qNM_RfL8uTxsj8y1rICVL_AFjvw4M?usp=sharing',
    galleryWebsite: 'http://geary.nyc',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Sensa Fleur',
    booth: 'BA 1',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: 'New York,, NY',
    exhibitingArtists: '',
    textDescription:
      'Sensa Fleur is a sensorial universe where flowers become form, memory, and meaning. Through fragrance and experience, each creation traces the life of a flower—translating the ephemeral into permanence.',
    imagesLink: '',
    galleryWebsite: 'http://sensafleur.com/',
    priceListOrOVRLink: '',
  },
  {
    galleryName: 'Reve',
    booth: 'BA 2',
    fairLocation: 'Future Fair 535 W 28th St',
    galleryLocation: '',
    exhibitingArtists: '',
    textDescription:
      'Developed in collaboration with Independent Curator, Anne-Laure Lemaitre, the experience invites visitors to engage directly with the product through a series of prompts and image-making interactions.',
    imagesLink: '',
    galleryWebsite: '',
    priceListOrOVRLink: '',
  },
];

export const FUTUREFAIR_2026_DATA_BY_BOOTH =
  Object.fromEntries(FUTUREFAIR_2026_DATA.map(entry => [entry.booth, entry]));
